import {Component, Input, OnInit} from '@angular/core';
import {CheckUp} from '../../../data/model/checkUp';
import {FileExamenList} from '../../../data/model/examen';
import {ClinicalCaseService} from '../../../services/clinical-case.service';

@Component({
  selector: 'app-examen-imagerie',
  templateUrl: './check-up-image.component.html',
  styleUrls: ['./check-up-image.component.css']
})
export class CheckUpImageComponent implements OnInit {

  selectedFiles: FileExamenList[] = [];
  step = -1; // current expansion pane opened (if one is opened)

  // all types of expansion pane
  @Input() checkUps: CheckUp[] = [new CheckUp(1, 'Radio', [], '', 10),
    new CheckUp(1, 'dynamic', [], '', 10),
    new CheckUp(1, 'scanner', [], '', 10),
    new CheckUp(1, 'artro', [], '', 10),
    new CheckUp(1, 'IRM', [], '', 10),
    new CheckUp(1, 'scintigraphy', [], '', 10)];

  // new categories added by user
  newExams: number[] = [];

  constructor(private clinicalCaseService: ClinicalCaseService) {
  }

  ngOnInit(): void {
    this.checkUps = this.clinicalCaseService.getClinicalCase().checkUpImagesList;
  }

  nextStep(): void {
    this.step++;
  }

  prevStep(): void {
    this.step--;
  }

  setStep(idx: number): void {
    this.step = idx;
  }

  addExam(): void {
    this.checkUps.push({idCC: 0, checkUpType: 'Autre examen : ', media: [], result: '', time: 0, title: ['']});
    this.newExams.push(this.checkUps.length - 1);
    this.step = this.checkUps.length - 1;
  }

  removeExam(idx: number): void {
    if (this.isNewExam(idx)) {
      this.checkUps.splice(idx, 1);
    }
  }

  isNewExam(idx: number): boolean {
    return this.newExams.includes(idx);
  }

  onFileSelected(event: any): void {
    this.selectedFiles.push({file: event.target.files[0], id: this.step});
  }

  saveData(): void {
    this.clinicalCaseService.saveCheckUpImage(this.checkUps);
  }

  stepHasFile(): boolean {
    if (this.selectedFiles.length > 0) {
      for (const file of this.selectedFiles) {
        if (file.id === this.step) {
          return true;
        }
      }
    }
    return false;
  }

}
